import { siteConfig } from "./siteConfig";

export function createWebsiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteConfig.siteName,
    url: siteConfig.siteUrl,
    description: siteConfig.defaultDescription,
    inLanguage: "tr-TR",
    publisher: {
      "@type": "Person",
      name: siteConfig.siteName,
      url: siteConfig.siteUrl,
    },
  };
}

export function createPersonSchema(profile) {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    name: profile.name,
    jobTitle: profile.role,
    description: profile.extendedBio,
    email: profile.email,
    address: {
      "@type": "PostalAddress",
      addressLocality: profile.location,
    },
    url: siteConfig.siteUrl,
    sameAs: profile.sameAs || [],
  };
}

export function createProfilePageSchema(profile) {
  return {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    name: `${profile.name} Hakkimda`,
    url: `${siteConfig.siteUrl}/hakkimda`,
    mainEntity: createPersonSchema(profile),
  };
}

export function createBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function createArticleSchema(post, authorName) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    description: post.excerpt,
    image: [siteConfig.defaultImage],
    datePublished: post.publishedAt,
    dateModified: post.publishedAt,
    author: {
      "@type": "Person",
      name: authorName,
    },
    publisher: {
      "@type": "Person",
      name: authorName,
    },
    mainEntityOfPage: `${siteConfig.siteUrl}/blog/${post.slug}`,
    articleSection: post.category,
    keywords: post.tags.join(", "),
    inLanguage: "tr-TR",
  };
}

export function createCollectionPageSchema({
  title,
  description,
  url,
  itemUrls = [],
}) {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: title,
    description,
    url,
    hasPart: itemUrls.map((item) => ({
      "@type": "WebPage",
      url: item,
    })),
  };
}

export function createSoftwareApplicationSchema(app) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: app.name,
    description: app.description,
    applicationCategory: app.category,
    operatingSystem: app.platform.join(", "),
    softwareVersion: app.status,
    url: `${siteConfig.siteUrl}/myappshop/${app.slug}`,
    image: siteConfig.defaultImage,
    offers:
      app.storeUrl && app.storeUrl !== "#"
        ? {
            "@type": "Offer",
            url: app.storeUrl,
            price: "0",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
          }
        : undefined,
  };
}
